import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AdminService } from '../../shared/services/admin.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../shared/elements/loader/loader.component';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { AdminTableDataComponent } from '../shared-data/table-data/admin-table-data.component';
import { AppModalComponent } from '../../shared/elements/app-modal/app-modal.component';
import { EditDataPopupComponent } from '../shared-data/edit-data-popup/edit-data-popup.component';


@Component({
    selector: 'app-lookup-editor',
    templateUrl: './lookup-editor.component.html',
    styleUrls: ['./lookup-editor.component.css'],
    imports: [LoaderComponent, MatFormField, MatSelect, FormsModule, MatOption, AdminTableDataComponent, AppModalComponent, EditDataPopupComponent]
})
export class LookupEditorComponent implements OnInit {
  @Input() lookupTables: any = [];
  @ViewChild('editDataPopup') editDataPopup;
  selectedLookupTable: string = '';
  closePopup: boolean = false;
  wq_dataSource: MatTableDataSource<any>;
  app_attr_dataSource: MatTableDataSource<any>;
  lookup_no_hry_dataSource: MatTableDataSource<any>;
  lookup_with_hry_dataSource: MatTableDataSource<any>;
  ui_dynamic_content_table_dataSource: MatTableDataSource<any>;
  video_library_dataSource: MatTableDataSource<any>;
  dropdownData = [];
  editFlag: boolean = false;
  tableNameCloseVar: any;
  emitReqPayloadVar: any;
  updateAppAttributeVar: any;
  updateLookupNoHryVar: any;
  updateLookupWithHryVar: any;
  wq_displayedColumns: string[] = ['workqueue', 'create_req_roles', 'approve_req_roles', 'updated_at', 'updated_by'];
  app_attr_displayedColumns: string[] = ['attribute_name', 'selection', 'hierarchy', 'editable', 'visual_order'];
  lookup_no_hry_displayedColumns: string[] = ['attribute', 'value', 'edit_drop_down', 'view_drop_down', 'updatedAt', 'updated_by'];
  lookup_with_hry_displayedColumns: string[] = ['attribute', 'value', 'sub_value', "edit_drop_down", "view_drop_down", 'updatedAt', 'updated_by'];
  ui_dynamic_content_table: string[] = ['PageName', "Occurance", 'Category', "Content", 'visibility', 'Audience', 'Role_Visibility', 'updatedAt', 'updatedByName'];
  video_library_table: string[] = ['title', "category", "video_blobname", 'vtt_text'];
  WQ_MSTR_COL = [
    {
      columnDef: 'workqueue',
      header: 'Workqueue',
      width: '13%',
    },
    {
      columnDef: 'create_req_roles',
      header: 'Create Request Roles',
      width: '13%',
    },
    {
      columnDef: 'approve_req_roles',
      header: 'Approve Request Roles',
      width: '13%',
    },
    {
      columnDef: 'create_new_dropdown',
      header: 'Create New Dropdown',
      width: '13%',
    },
    {
      columnDef: 'view_visibility',
      header: 'View Visibility',
      width: '9%',
    },
    {
      columnDef: 'updated_at',
      header: 'Updated At',
      isSort: true
    },
    {
      columnDef: 'updated_by',
      header: 'Updated By',
    },
    {
      columnDef: 'Actions',
      header: 'Action',
      displayText: 'Edit',

    }
  ];
  APP_ATTR_COL = [
    {
      columnDef: 'attribute_name',
      header: 'Attribute Name',

    },
    {
      columnDef: 'selection',
      header: 'Selection',

    },
    {
      columnDef: 'hierarchy',
      header: 'Hierarchy',

    },
    {
      columnDef: 'editable',
      header: 'Editable',
    },
    {
      columnDef: 'visual_order',
      header: 'Visual order',
    },
    {
      columnDef: 'Actions',
      header: 'Action',
      displayText: 'Edit',
    }
  ];
  LOOKUP_NO_HRY_COL = [
    {
      columnDef: 'attribute',
      header: 'Attribute',
    },
    {
      columnDef: 'value',
      header: 'Value',
    },
    {
      columnDef: 'edit_drop_down',
      header: 'Edit Drop Down',
    },
    {
      columnDef: 'view_drop_down',
      header: 'View Drop Down',
    },
    {
      columnDef: 'updatedAt',
      header: 'Updated At',
      isSort: true
    },
    {
      columnDef: 'updated_by',
      header: 'Updated By',
    },
    {
      columnDef: 'Actions',
      header: 'Action',
      displayText: 'Edit',
    }
  ];
  LOOKUP_WITH_HRY_COL = [
    {
      columnDef: 'attribute',
      header: 'Attribute',
      width: '20%'
    },
    {
      columnDef: 'value',
      header: 'Value',

    },
    {
      columnDef: 'sub_value',
      header: 'Sub Value',

    },
    {
      columnDef: 'edit_drop_down',
      header: 'Edit Dropdown',
    },
    {
      columnDef: 'view_drop_down',
      header: 'View Dropdown',
    },
    {
      columnDef: 'updatedAt',
      header: 'Updated At',
      isSort: true
    },
    {
      columnDef: 'updated_by',
      header: 'Updated By',
    },
    {
      columnDef: 'Actions',
      header: 'Action',
      displayText: 'Edit',
    }
  ];
  createReqRolesDropdown: any = [
    {
      id: 'AD',
      name: 'AD'
    },
    {
      id: 'CA',
      name: 'CA'
    },
    {
      id: 'Admin',
      name: 'Admin'
    },
    {
      id: 'System',
      name: 'System'
    }
  ]
  approveReqRolesDropdown: any = [
    {
      id: 'AD',
      name: 'AD'
    },
    {
      id: 'CA',
      name: 'CA'
    },
    {
      id: 'Admin',
      name: 'Admin'
    },
    {
      id: 'System',
      name: 'System'
    }
  ];
  workQueuesDropdown: any = ["LOB Update", "New LOB Assignment"];
  yesNoDropdownValues: any = ["Yes", "No"];
  selectionDropdown: any = ["Single", "Multi"];
  hierarchyDropdown: any = [0, 1, 2, 3];
  visualOrderDropdown: any = [];
  attributeDropdown: any = [];
  attributeHryDropdown: any = [];
  appattributeDropdown: any = [];
  valueHryDropdown: any = [];
  workQueueFormFields = [
    {
      'label': "Select Work Queue",
      'inputType': "singleSelect",
      'fcname': "workQueue",
      'placeholder': "Select Work Queue",
      'dropdownData': this.workQueuesDropdown
    },
    {
      'label': "Approve Request Roles",
      'inputType': "multiSelect",
      'fcname': "approveReqRole",
      'placeholder': "Select Approve Req Roles",
      'dropdownData': this.approveReqRolesDropdown
    },
    {
      'label': "Create Request Roles",
      'inputType': "multiSelect",
      'fcname': "createReqRole",
      'placeholder': "Select Create Req Roles",
      'dropdownData': this.createReqRolesDropdown
    },
    {
      'label': "Create New Dropdown",
      'inputType': "singleSelect",
      'fcname': "createDropdown",
      'placeholder': "Create New Dropdown",
      'dropdownData': this.yesNoDropdownValues
    },
    {
      'label': "View visibility",
      'inputType': "singleSelect",
      'fcname': "viewVisibility",
      'placeholder': "View visibility",
      'dropdownData': this.yesNoDropdownValues
    }
  ];
  AppAttributeFormFields = [
    {
      'label': "Attribute Name",
      'inputType': "singleSelect",
      'fcname': "attribute",
      'placeholder': "Selection",
      'dropdownData': this.appattributeDropdown
    },
    {
      'label': "Selection",
      'inputType': "singleSelect",
      'fcname': "selection",
      'placeholder': "Selection",
      'dropdownData': this.selectionDropdown
    },
    {
      'label': "Hierarchy",
      'inputType': "singleSelect",
      'fcname': "hierarchy",
      'placeholder': "Select Heirarchy",
      'dropdownData': this.hierarchyDropdown
    },
    {
      'label': "Editable",
      'inputType': "singleSelect",
      'fcname': "editable",
      'placeholder': "Editable",
      'dropdownData': this.yesNoDropdownValues
    },
    {
      'label': "Visual order",
      'inputType': "singleSelect",
      'fcname': "visualorder",
      'placeholder': "Select visual order",
      'dropdownData': this.visualOrderDropdown
    }
  ];
  lookupNoHryFormFields = [
    {
      'label': "Attribute",
      'inputType': "singleSelect",
      'fcname': "attribute",
      'placeholder': "Select Attribute",
      'dropdownData': this.attributeDropdown
    },
    {
      'label': "Value",
      'inputType': "text",
      'fcname': "value",
      'placeholder': "Select Value",
      'dropdownData': null
    },
    {
      'label': "Edit Dropdown",
      'inputType': "singleSelect",
      'fcname': "editDropdown",
      'placeholder': "Edit Dropdown",
      'dropdownData': this.yesNoDropdownValues
    },
    {
      'label': "View Dropdown",
      'inputType': "singleSelect",
      'fcname': "viewDropdown",
      'placeholder': "View Dropdown",
      'dropdownData': this.yesNoDropdownValues
    }
  ];
  lookupWithHryFormFields = [
    {
      'label': "Attribute",
      'inputType': "singleSelect",
      'fcname': "attributeHry",
      'placeholder': "Select Attribute",
      'dropdownData': this.attributeHryDropdown
    },
    {
      'label': "Value",
      'inputType': "text",
      'fcname': "valueHry",
      'placeholder': "Select Value",
      'dropdownData': null
    },
    {
      'label': "Sub Value",
      'inputType': "text",
      'fcname': "subvalueHry",
      'placeholder': "Enter Sub Value",
      'dropdownData': null
    },
    {
      'label': "Edit Dropdown",
      'inputType': "singleSelect",
      'fcname': "editDropdownHry",
      'placeholder': "Edit Dropdown",
      'dropdownData': this.yesNoDropdownValues
    },
    {
      'label': "View Dropdown",
      'inputType': "singleSelect",
      'fcname': "viewDropdownHry",
      'placeholder': "View Dropdown",
      'dropdownData': this.yesNoDropdownValues
    }
  ];
  addLookupWithHryFormFields = [
    {
      'label': "Attribute",
      'inputType': "singleSelect",
      'fcname': "attributeHry",
      'placeholder': "Select Attribute",
      'dropdownData': this.attributeHryDropdown
    },
    {
      'label': "Value",
      'inputType': "textSelect",
      'fcname': "valueHry",
      'placeholder': "Select Value",
      'dropdownData': this.valueHryDropdown
    },
    {
      'label': "Sub Value",
      'inputType': "text",
      'fcname': "subvalueHry",
      'placeholder': "Enter Sub Value",
      'dropdownData': null
    },
    {
      'label': "Edit Dropdown",
      'inputType': "singleSelect",
      'fcname': "editDropdownHry",
      'placeholder': "Edit Dropdown",
      'dropdownData': this.yesNoDropdownValues
    },
    {
      'label': "View Dropdown",
      'inputType': "singleSelect",
      'fcname': "viewDropdownHry",
      'placeholder': "View Dropdown",
      'dropdownData': this.yesNoDropdownValues
    }
  ];
  addLookupWitNohHryFormFields = [
    {
      'label': "Attribute",
      'inputType': "singleSelect",
      'fcname': "attributeHry",
      'placeholder': "Select Attribute",
      'dropdownData': this.attributeDropdown
    },
    {
      'label': "Value",
      'inputType': "text",
      'fcname': "valueHry",
      'placeholder': "Enter Value",
      'dropdownData': null
    },
    {
      'label': "Edit Dropdown",
      'inputType': "singleSelect",
      'fcname': "editDropdownHry",
      'placeholder': "Edit Dropdown",
      'dropdownData': this.yesNoDropdownValues
    },
    {
      'label': "View Dropdown",
      'inputType': "singleSelect",
      'fcname': "viewDropdownHry",
      'placeholder': "View Dropdown",
      'dropdownData': this.yesNoDropdownValues
    }
  ];

  uiDynamicContentFormFields = [
    {
      'label': "Page Name",
      'inputType': "text",
      'fcname': "PageName",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Category",
      'inputType': "text",
      'fcname': "Catagory",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Audience",
      'inputType': "text",
      'fcname': "Audience",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Visibility",
      'inputType': "radio",
      'fcname': "visibility",
      'placeholder': "Enter Value",
      'dropdownData': ['True', 'False'],
      'mandatory': true
    },
    {
      'label': "Pop Up",
      'inputType': "radio",
      'fcname': "Popup",
      'placeholder': "Enter Value",
      'dropdownData': ['True', 'False'],
      'mandatory': true
    },
    {
      'label': "Cost Data",
      'inputType': "radio",
      'fcname': "CostData",
      'placeholder': "Enter Value",
      'dropdownData': ['Yes', 'No'],
      'mandatory': true
    },
    {
      'label': "Content",
      'inputType': "text",
      'fcname': "Content",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Occurance",
      'inputType': "number",
      'fcname': "Occurance",
      'placeholder': "Enter Value in number",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Role Visibility",
      'inputType': "text",
      'fcname': "Role_Visibility",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Url Path",
      'inputType': "text",
      'fcname': "Url_Path",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': false
    },
    {
      'label': "Icon",
      'inputType': "text",
      'fcname': "icon",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': false
    },
    {
      'label': "Description",
      'inputType': "textarea",
      'fcname': "Description",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': false
    }
  ]

  videoLibraryFormFields = [
    {
      'label': "Title",
      'inputType': "text",
      'fcname': "title",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Category",
      'inputType': "text",
      'fcname': "category",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Video File Name",
      'inputType': "text",
      'fcname': "video_blobname",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    },
    {
      'label': "Vtt Text",
      'inputType': "textarea",
      'fcname': "vtt_text",
      'placeholder': "Enter Value",
      'dropdownData': null,
      'mandatory': true
    }
  ]

  wqList: any = [];
  dataToEdit: any;
  popHeader: string;
  popupHeader: string;
  formfields: any;
  tableName: string;
  formGroupName: string;
  ahL0Ids: any = {};
  showLoader: boolean = false;
  UI_CONTENT_DYNAMIC_COL = [
    {
      columnDef: 'PageName',
      header: 'Page Name',
    },
    {
      columnDef: 'Occurance',
      header: 'Occurance',
    },
    {
      columnDef: 'Catagory',
      header: 'Category',
    },
    {
      columnDef: 'Content',
      header: 'Content',
    },
    {
      columnDef: 'visibility',
      header: 'Visibility',
    },
    {
      columnDef: 'Audience',
      header: 'Audience',
    },
    {
      columnDef: 'Role_Visibility',
      header: 'Role Visibility',
    },
    {
      columnDef: 'updatedAt',
      header: 'Updated At',
    },
    {
      columnDef: 'updatedByName',
      header: 'Updated By',
    },
    {
      columnDef: 'Actions',
      header: 'Action',
      displayText: 'Edit',
    }
  ];

  VIDEO_LIBRARY_COL = [
    {
      columnDef: 'title',
      header: 'Title',
    },
    {
      columnDef: 'category',
      header: 'Category',
    },
    {
      columnDef: 'video_blobname',
      header: 'Video Blob',
    },
    {
      columnDef: 'vtt_text',
      header: 'Vtt Text',
    },
    {
      columnDef: 'Actions',
      header: 'Action',
      displayText: 'Edit',
    }
  ];

  constructor(public admnsrv: AdminService, public datepipe: DatePipe, public toaster: ToastrService) { }


  ngOnInit() {
    this.selectedLookupTable = 'WQ_MSTR'
    this.getWorkQueueMasterData();
    this.getAppAttributeDetails();
    this.getLookupNoHry();
    this.getLookupWithHry();
    this.getUIdynamicTableData();
    this.getVideoLibraryData();
    this.wqList = [{
      "value": "LOB Update",
      "id": "LOB_Update"
    }, {
      "value": "New LOB Assignment",
      "id": "New_LOB_Assignment"
    }]
  }

  /**
* @author: Menagadevi
* @description: This methods helps to fetch the lookup with 1 hierarchy data by making an API call.
*/
  getLookupWithHry() {
    this.showLoader = true;
    this.admnsrv.getLookupWithHryData().subscribe((response: any) => {
      this.showLoader = false;
      this.modifyDates(response.result);
      this.lookup_with_hry_dataSource = new MatTableDataSource(response.result);
      this.valueHryDropdown = new Set(response.result.map(x => x.value));
      this.ahL0Ids = response.result.map(({ value, AH_L0_ID }) => ({ value, AH_L0_ID }));
      this.attributeHryDropdown = new Set(response.result.map(x => x.attribute));
      this.lookupWithHryFormFields[0].dropdownData = this.attributeHryDropdown;
      this.addLookupWithHryFormFields[0].dropdownData = this.attributeHryDropdown;
      this.addLookupWithHryFormFields[1].dropdownData = this.valueHryDropdown;
    },
      (err) => {
        this.showErrMsg(err);


      })
  }

  /**
* @author: Menagadevi
* @description: This methods helps to fetch the lookup with no hierarchy data by making an API call.
*/
  getLookupNoHry() {
    this.showLoader = true;
    this.admnsrv.getLookupNoHryData().subscribe((response: any) => {
      this.showLoader = false;
      this.modifyDates(response.result);
      this.lookup_no_hry_dataSource = new MatTableDataSource(response.result);
      this.attributeDropdown = [...new Set(response.result.map(x => x.attribute))];
      this.lookupNoHryFormFields[0].dropdownData = this.attributeDropdown;
      this.addLookupWitNohHryFormFields[0].dropdownData = this.attributeDropdown;
    },
      (err) => {
        this.showErrMsg(err);

      })
  }

  /**
* @author: Menagadevi
* @description: This methods helps to fetch the lookup with no hierarchy data by making an API call.
*/
  getAppAttributeDetails() {
    this.showLoader = true;
    this.admnsrv.getAppAttrData().subscribe((response: any) => {
      this.showLoader = false;
      this.app_attr_dataSource = new MatTableDataSource(response.result);
      this.visualOrderDropdown = [];
      response.result.forEach((_elem, index) => {
        this.visualOrderDropdown.push(index + 1);
      });
      this.appattributeDropdown = [...new Set(response.result.map(x => x.attribute_name))];
      this.AppAttributeFormFields[0].dropdownData = this.appattributeDropdown;
      this.AppAttributeFormFields[4].dropdownData = this.visualOrderDropdown;

    },
      (err) => {
        this.showErrMsg(err);

      })
  }
  getWorkQueueMasterData() {
    this.showLoader = true;
    this.admnsrv.getWorkQueueData().subscribe((response: any) => {
      this.showLoader = false;
      this.modifyDates(response.result);
      this.workQueuesDropdown = response.result.map(x => x.workqueue);
      this.workQueueFormFields[0].dropdownData = this.workQueuesDropdown;
      this.wq_dataSource = new MatTableDataSource(response.result);
    },
      (err) => {
        if (err && err.message) {
          this.showErrMsg(err);
        }
      })
  }


  modifyDates(data) {
    data.forEach(element => {

      if (element['updated_at']) {
        element['updated_at'] = this.datepipe.transform(element['updated_at'], 'dd/MM/yyyy,h:mm a');
      }
      if (element['updatedAt']) {
        element['updatedAt'] = this.datepipe.transform(element['updatedAt'], 'dd/MM/yyyy,h:mm a');
      }
    });
    return data;
  }

  closeModal(tableName: string) {
    this.tableNameCloseVar = tableName;
    this.closePopup = true;
  }

  editWorkQueue(event) {
    this.editFlag = true;
    if (event.tableName == 'WQ_MSTR') {
      this.dataToEdit = event.data;
      this.popupHeader = "Update Role";
      this.formfields = this.workQueueFormFields;
      this.editDataPopup.show();
      this.tableName = "WQ_MSTR";

    }
    else if (event.tableName == 'APP_ATTR') {
      this.dataToEdit = event.data;
      this.editDataPopup.show();
      this.formfields = this.AppAttributeFormFields;
      this.popupHeader = "Update App Attribute : " + this.dataToEdit.attribute_name;
      this.tableName = "APP_ATTR";
    }
    else if (event.tableName == 'LOOKUP_NO_HRY') {
      this.dataToEdit = event.data;
      this.editDataPopup.show();
      this.formfields = this.lookupNoHryFormFields;
      this.popupHeader = "Update lookup with no hierarchy : " + this.dataToEdit.attribute;
      this.tableName = "LOOKUP_NO_HRY";
    }
    else if (event.tableName == 'LOOKUP_WITH_HRY') {
      this.dataToEdit = event.data;
      this.editDataPopup.show();
      this.formfields = this.lookupWithHryFormFields;
      this.popupHeader = "Update lookup with hierarchy : " + this.dataToEdit.attribute;
      this.tableName = "LOOKUP_WITH_HRY";
    }
    else if (event.tableName == 'UI_DYNAMIC_CONTENT_TABLE') {
      this.closePopup = false;
      this.dataToEdit = event.data;
      this.editDataPopup.show();
      this.formfields = this.uiDynamicContentFormFields;
      this.popupHeader = "Update UI dynamic content : " + this.dataToEdit.PageName;
      this.tableName = "UI_DYNAMIC_CONTENT_TABLE";
    }
    else if (event.tableName == 'VIDEO_LIBRARY') {
      this.closePopup = false;
      this.dataToEdit = event.data;
      this.editDataPopup.show();
      this.formfields = this.videoLibraryFormFields;
      this.popupHeader = "Update Video VTT Text for  : " + this.dataToEdit.title;
      this.tableName = "VIDEO_LIBRARY";
    }
  }

  emitReqPayload(event) {
    if (event.tableName == "WQ_MSTR") {
      this.showLoader = true;
      this.admnsrv.updateWorkQueueRole(event.payload).subscribe((response) => {
        this.emitReqPayloadVar = response;
        this.editDataPopup.hide();
        this.showSuccessMsg('Data updated Successfully.');
        this.getWorkQueueMasterData();
      },
        (err) => {
          this.editDataPopup.hide();
          this.showErrMsg(err);
        })
    }
    else if (event.tableName == "APP_ATTR") {
      this.showLoader = true;
      this.admnsrv.updateAppAttribute(event.payload).subscribe((response) => {
        this.updateAppAttributeVar = response;
        this.editDataPopup.hide();
        this.showSuccessMsg('Data updated Successfully.');
        this.getAppAttributeDetails();
      }, (err) => {
        this.editDataPopup.hide();
        this.showErrMsg(err);
      })
    }
    else if (event.tableName == "LOOKUP_NO_HRY") {
      this.showLoader = true;
      this.admnsrv.updateLookupNoHry(event.payload).subscribe((response) => {
        this.updateLookupNoHryVar = response;
        this.editDataPopup.hide();
        this.showSuccessMsg('Data updated Successfully.');
        this.getLookupNoHry();
      }, (err) => {
        this.editDataPopup.hide();
        this.showErrMsg(err);
      })
    } else if (event.tableName == "LOOKUP_WITH_HRY") {
      this.showLoader = true;
      this.admnsrv.updateLookupWithHry(event.payload).subscribe((response) => {
        this.updateLookupWithHryVar = response;
        this.editDataPopup.hide();
        this.showSuccessMsg('Data updated Successfully.');
        this.getLookupWithHry();
      }, (err) => {
        this.editDataPopup.hide();
        this.showErrMsg(err);

      })
    }
    else if (event.tableName == "ADD_LOOKUP_WITH_HRY") {
      this.showLoader = true;
      const index = this.ahL0Ids.findIndex(o => event.payload.value === o.value);
      if (index >= 0)
        event.payload["AH_L0_ID"] = this.ahL0Ids[index].AH_L0_ID;
      else {
        event.payload["AH_L0_ID"] = null;
      }
      this.admnsrv.addLookupWithHry(event.payload).subscribe((response) => {
        this.editDataPopup.hide();
        this.showSuccessMsg(response.message);
        this.getLookupWithHry();
      }, (err) => {
        this.editDataPopup.hide();
        this.showErrMsg(err);
      })
    }
    else if (event.tableName == "ADD_LOOKUP_WITH_NO_HRY") {
      this.showLoader = true;
      this.admnsrv.addLookupWithNoHry(event.payload).subscribe((response) => {
        this.editDataPopup.hide();
        this.showSuccessMsg(response.message);
        this.getLookupNoHry();
      }, (err) => {
        this.editDataPopup.hide();
        this.showErrMsg(err);
      })
    } else if (event.tableName == "UI_DYNAMIC_CONTENT_TABLE") {
      this.showLoader = true;
      if (event.payload.ID) {
        this.admnsrv.updateUIdynamicTableContent(event.payload).subscribe((response) => {
          this.editDataPopup.hide();
          this.showSuccessMsg(response.message);
          this.getUIdynamicTableData();
        }, (err) => {
          this.showErrMsg(err);
        })
      } else {
        this.admnsrv.addUIdynamicTableContent(event.payload).subscribe((response) => {
          this.editDataPopup.hide();
          this.showSuccessMsg(response.message);
          this.getUIdynamicTableData();
        }, (err) => {
          this.showErrMsg(err);
        })
      }
    }

    // New code for Video Library Table

    else if (event.tableName === "VIDEO_LIBRARY") {
      this.showLoader = true;
      if (event.payload.ID) {
        this.admnsrv.updateVideoLibrary(event.payload).subscribe(
          (response) => {
            this.editDataPopup.hide();
            this.showSuccessMsg(response.message);
            this.getVideoLibraryData();
          },
          (err) => this.showErrMsg(err)
        );
      }
    }

  }
  showErrMsg(err: any) {
    this.showLoader = false;
    if (err && err.error && err.error.message) {
      this.toaster.error(err.error.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
    else if (err && err.message) {
      this.toaster.error(err.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    } else {
      this.toaster.error('Something went wrong', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  showSuccessMsg(msg: any) {
    this.showLoader = false;
    if (msg) {
      this.toaster.success(msg, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  addHry() {
    this.dataToEdit = {};
    this.editDataPopup.show();
    this.formfields = this.addLookupWithHryFormFields;
    this.popupHeader = "Add lookup with hierarchy";
    this.tableName = "ADD_LOOKUP_WITH_HRY";
    this.editFlag = false;
  }

  addNoHry() {
    this.dataToEdit = {};
    this.editDataPopup.show();
    this.formfields = this.addLookupWitNohHryFormFields;
    this.popupHeader = "Add lookup no hierarchy";
    this.tableName = "ADD_LOOKUP_WITH_NO_HRY";
    this.editFlag = false;
  }

  addDynamicContent() {
    this.dataToEdit = {};
    this.formfields = this.uiDynamicContentFormFields;
    this.editDataPopup.show();
    this.popupHeader = "Add UI dynamic content";
    this.tableName = "UI_DYNAMIC_CONTENT_TABLE";
    this.editFlag = false;
  }

  getUIdynamicTableData() {
    this.showLoader = true;
    this.admnsrv.getUIdynamicTableContent().subscribe((response: any) => {
      this.showLoader = false;
      response.result = this.modifyDates(response.result);
      this.ui_dynamic_content_table_dataSource = new MatTableDataSource(response.result);
      (err) => {
        this.showErrMsg(err);
      }
    })
  }

  getVideoLibraryData() {
    this.showLoader = true;
    this.admnsrv.getVideoLibraryData().subscribe((response: any) => {
      this.showLoader = false;
      response.result = this.modifyDates(response.result);
      this.video_library_dataSource = new MatTableDataSource(response.result);
      (err) => {
        this.showErrMsg(err);
      }
    })
  }
}